
import Vue from 'vue';
import { Component, Watch } from 'nuxt-property-decorator';
import type { Route } from 'vue-router';

@Component
export default class RefreshSnackbar extends Vue {
  openSnackBar!: boolean = false;
  refreshContentText!: string =
    'New content is available. Click refresh to update.';

  mounted() {
    this.addNotificationWhenPWAShouldBeRefreshed();
  }

  @Watch('$route')
  onRouteChange(_newRoute: Route) {
    this.addNotificationWhenPWAShouldBeRefreshed();
  }

  refreshClicked() {
    this.openSnackBar = false;
    window.location.reload();
  }

  private async addNotificationWhenPWAShouldBeRefreshed() {
    const workbox = await window.$workbox;

    if (workbox) {
      workbox.addEventListener('installed', (event) => {
        if (event.isUpdate) {
          this.openSnackBar = true;
        }
      });
    }
  }
}
